<template>
  <div class="headerAll">
    <div class="header ovh">
      <!-- 左侧导航图 -->
      <div class="navigation ovh f_l">
        <!-- logo -->
        <div class="logo f_l">
          <img src="../../static/logo.png" />
        </div>
        <!-- 导航 -->
        <div class="navigationList f_l" v-for="(item, index) in navigationList" :class="[navigationCode == item.val ? 'navigation_back_1' : 'navigation_back_2']" :key="index" @click="navigationClick(item)">
          {{item.name}}
        </div>
      </div>
      <!-- 右侧用户 -->
      <div class="navigationUser f_r">
        <!-- 未登录 -->
        <div class="noLogin" v-if="noLogin">
          <div class="f_r register" @click="register()">注册</div>
          <div class="f_r xian"></div>
          <div class="f_r login" @click="login()">登录</div>
        </div>
        <!-- 已登录 -->
        <div class="yeLogin ovh" v-if="!noLogin">
          <div class="f_r out" @click="logOut()">退出登录</div>
          <div class="f_r register">{{userName}}</div>
          <div class="f_r tipsImg">
            <img src="../../static/tip.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <mall-login v-if="loginVisble" ref="login" @loginReturn="loginReturn"></mall-login>
    <!-- 注册 -->
    <mall-register v-if="registerVisble" ref="register" @registerReturn="registerReturn"></mall-register>
  </div>
</template>

<script>
  // 登录
  import mallLogin from '@/components/login.vue';
  // 注册
  import mallRegister from '@/components/register.vue';

  export default {
    name: 'headTop',
    data () {
      return {
        navigationList: [{
          val: 0,
          name: '首页',
          url: 'index'
        },{
          val: 2,
          name: '我的订单',
          url: 'myOrder'
        }, {
          val: 3,
          name: '商家入驻',
          url: 'business'
        }, {
          val: 1,
          name: '关于我们',
          url: 'aboutUs',
          code: 0
        }, {
          val: 4,
          name: '联系我们',
          url: 'aboutUs',
          code: 1
        }],
        navigationOldList: [{
          val: 0,
          name: '首页',
          url: 'index'
        }, {
          val: 1,
          name: '关于我们'
        }, {
          val: 2,
          name: '身份认证'
        }, {
          val: 3,
          name: '商家入驻',
          url: 'business'
        }, {
          val: 4,
          name: '联系我们'
        }],
        userName: '', // 用户名
        navigationCode: null, // 用户点击的导航 
        noLogin: true, // 用户是否登录（true：未登录  false：已登录）
        loginVisble: false, // 登录弹框
        registerVisble: false, // 注册弹框
      }
    },

    mounted() {
      // 用户登录信息
      this.getInfo();
    },

    computed:{
      
    },

    components: {
      'mall-login': mallLogin, // 登录
      'mall-register': mallRegister // 注册
    },

    activated() {
      
    },

    methods:{
      // 选中导航赋值
      init(code) {
        this.navigationCode = code;
      },

      // 用户登录信息
      getInfo() {
        // 判断用户是否登录
        var name = localStorage.getItem('userName');
        if(name == null || name == 'null' || name == '' || name == undefined) {
          this.noLogin = true; // 用户是否登录
        }else {
          this.noLogin = false; // 用户是否登录
          this.userName = localStorage.getItem('userName');
        }
      },

      // 点击导航
      navigationClick(e) {
        if(e.url === undefined) {
          this.$message({
            showClose: true,
            message: '该功能完善中。敬请期待'
          });
          return;
        }
        // 关于我们/联系我们
        if(e.url === 'aboutUs') {
          var url = window.location.href;
          var index = url.lastIndexOf("\/");
          var str = url.substring(0, index + 1);
          localStorage.setItem('aboutCode', e.code)
          window.open(str + 'aboutUs');
          return;
        }else {
          this.navigationCode = e.val;
        }
        // 跳转页面
        this.$router.push({
          name: e.url,
          params: {}
        })
      },

      // 点击注册
      register() {
        this.registerVisble = true;
        this.$nextTick(() => {
          this.$refs.register.init()
        })
      },

      // 注册页面后返回执行的参数
      registerReturn(code) {
        this.registerVisble = false;
        if(code == 1) {
          // 点击登录
          this.login();
        }else if(code == 0) {
          // 注册成功
          // 查看用户登录信息
          this.getInfo();
        }
      },

      // 点击登录
      login() {
        this.loginVisble = true;
        this.$nextTick(() => {
          this.$refs.login.init()
        })
      },

      // 登录页面返回后执行的参数
      loginReturn(code) {
        this.loginVisble = false;
        if(code == 1) {
          // 点击注册
          this.register();
        }else if(code == 0) {
          // 登录成功
          // 查看用户登录信息
          this.getInfo();
        }
      },

      // 退出登录
      logOut() {
        localStorage.setItem('userName', '');
        localStorage.setItem('token', '');
        if (this.$route.path !== '/') {
          this.$router.push({path: '/' })
        }
        this.$message({
          type: 'success',
          message: '退出登录成功'
        });
        // 查看用户登录信息
        this.getInfo();
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  @import "../components/css/component.css";

  .headerAll {
    border-bottom: 1px solid #E3E4E4;
    background: #fff;
    font-size: 14px;
    cursor: pointer;
    position: fixed;
    width: 100%;
    z-index: 1;
  }

  .header {
    width: 1200px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
  }

  .navigation {
    
  }

  .logo {
    height: 30px;
    width: 130px;
    margin: 11px 44px 0 0;
  }

  .navigationList {
    padding: 0 16px;
  }

  .navigation_back_1 {
    background-color: #0F7DFF;
    color: #fff;
  }
  
  .navigation_back_2 {
    background-color: #fff;
    color: #434444;
  }

  .navigationUser {
    
  }

  .tipsImg {
    width: 16px;
    height: 16px;
    margin: 3px 20px 0 0;
  }

  .login {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #FE951E;
  }

  .xian {
    width: 2px;
    height: 15px;
    margin: 17px 10px 0 10px;
    background: #FE951E;
  }

  .register {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #FE951E;
  }

  .yeLogin {
    &> .out {
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 1px;
      color: #999;
      margin-left: 12px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/headTop.vue